/* DS-LADDER v3 — cart-aware shipping bar + 3rd-item offer.
   Rung 1 (free shipping) is DOLLAR-based on the cart subtotal, because that is
   how the Shopify automatic free-shipping discount qualifies. Rung 2 (3rd item)
   is QUANTITY-based and counts ONLY items sharing this product's product_type,
   because the BXGY discounts are per-type — mixed carts do not qualify.
   Every number comes from block settings / the live cart via data-attributes. */
window.DSVeLadder = function (root) {
  const el = root.querySelector('[data-ve-ladder]');
  const sheet = root.querySelector('[data-ve-sheet]');

  // ── currency ────────────────────────────────────────────────────────────
  // The threshold is a plain block integer in SHOP currency, but cart totals
  // and price_now arrive in PRESENTMENT currency. The AU market is live, so
  // without this an AUD shopper is measured against a USD number.
  function fxRate() {
    const r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return (isFinite(r) && r > 0) ? r : 1;
  }
  function money(v) {
    // Use the theme's own formatter so non-USD markets render correctly, then
    // drop a zero decimal group — "$55" reads better than "$55.00" in a nudge,
    // and this also handles "55,00 €" style formats.
    try {
      if (window.theme && typeof theme.formatMoney === 'function') {
        return theme.formatMoney(Math.round(v * 100), window.theme.moneyFormat)
                    .replace(/([.,])00(?=\D|$)/, '');
      }
    } catch (e) {}
    return '$' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }
  function num(v, fallback) { const n = parseFloat(v); return isFinite(n) ? n : fallback; }

  function cfg() {
    const g = k => el.getAttribute(k);
    const qb = parseInt(g('data-ve-qty-bogo'), 10);
    return {
      type: (g('data-ve-ladder-type') || '').toLowerCase().trim(),
      shipTh: num(g('data-ve-ship-threshold'), 55) * fxRate(),
      qtyBogo: (isFinite(qb) && qb >= 2) ? qb : 3,
      pct: num(g('data-ve-bogo-pct'), 50),
      unit: num(g('data-ve-unit-price'), 0)
    };
  }
  const I = window.dsI18n || {};
  const ord = n => ({1:I.ord_1,2:I.ord_2,3:I.ord_3,4:I.ord_4,5:I.ord_5,6:I.ord_6})[n] || (I.ord_n || '').replace('{n}', n);

  // ONE ask at a time. Free shipping first; only once that is banked do we
  // mention the discounted extra item — the 50%-off offer is already stated
  // above the CTA and in the banner block, so repeating it here just competes.
  function render(total, qty) {
    if (!el) return;
    const c = cfg();
    const t = k => el.getAttribute('data-ve-t-' + k) || '';
    const all = sel => root.querySelectorAll(sel);
    const toFree = Math.max(0, c.shipTh - total);
    const shipDone = toFree <= 0;
    const bogoDone = qty >= c.qtyBogo;
    const disc = c.unit * (1 - c.pct / 100);
    let label, goalTxt, pct;

    if (total <= 0) {
      // Nothing in the bag yet: state the price of entry, not "add N more".
      label = t('empty').replace('{amount}', money(c.shipTh));
      goalTxt = (window.dsI18n && window.dsI18n.ladder_cap) || (money(c.shipTh) + '+');
      pct = 0;
    } else if (!shipDone) {
      // Ask in ITEMS, not dollars: "$27 more" is meaningless when the only
      // thing you can add costs $38. Round up to whole units of this product.
      const needUnits = c.unit > 0 ? Math.max(1, Math.ceil(toFree / c.unit)) : 1;
      label = t('rung1').replace('{remaining}', needUnits);
      goalTxt = (window.dsI18n && window.dsI18n.ladder_cap) || (money(c.shipTh) + '+');
      pct = c.shipTh > 0 ? Math.min(100, (total / c.shipTh) * 100) : 0;
    } else if (!bogoDone) {
      // "Add a third" is only true when ONE more is needed. A mixed cart can
      // bank free shipping while this product's own count is still 0 or 1, so
      // fall back to a plural line that names the real number.
      const remaining = c.qtyBogo - qty;
      label = (remaining > 1 ? (t('rung2-multi') || t('rung2')) : t('rung2'))
        .replace('{remaining}', remaining)
        .replace('{ordinal}', ord(c.qtyBogo))
        .replace('{price}', money(disc))
        .replace('{percent}', c.pct);
      goalTxt = (I.ladder_items || '').replace('{n}', c.qtyBogo);
      pct = Math.min(100, (qty / c.qtyBogo) * 100);
    } else {
      label = t('rung2-done')
        .replace('{ordinal}', ord(c.qtyBogo))
        .replace('{price}', money(disc))
        .replace('{percent}', c.pct);
      goalTxt = '';
      pct = 100;
    }

    all('[data-ve-ladder-label]').forEach(function (e) { e.textContent = label; });
    all('[data-ve-ladder-goal]').forEach(function (e) { e.textContent = goalTxt; });
    all('[data-ve-ladder-fill]').forEach(function (e) {
      e.style.width = pct + '%';
      e.classList.toggle('done', bogoDone);
    });
    all('[data-ve-ladder-won]').forEach(function (e) { e.hidden = !shipDone; });

    const bagBtn = root.querySelector('[data-ve-sheet-bag]');
    if (bagBtn) {
      if (bagBtn.dataset.veLabel === undefined) bagBtn.dataset.veLabel = bagBtn.textContent.trim();
      bagBtn.textContent = bagBtn.dataset.veLabel + ' (' + (window.__veCartCount || 0) + ')';
    }
  }

  async function sync() {
    if (!el) return;
    try {
      // /cart.js is cacheable — without no-store the browser serves a stale
      // copy and the bar reads one mutation behind (a removal looks ignored).
      const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      const cart = await res.json();
      const type = cfg().type;
      const qty = (cart.items || []).reduce(function (s, it) {
        return (it.product_type || '').toLowerCase().trim() === type ? s + (it.quantity || 0) : s;
      }, 0);
      window.__veCartCount = cart.item_count || 0;
      // items_subtotal_price matches how Shopify evaluates a minimum-subtotal
      // requirement. total_price is POST cart-discount, so once the BOGO fires
      // it can dip back under the threshold and flip "unlocked" off again.
      const basis = isFinite(cart.items_subtotal_price) ? cart.items_subtotal_price : (cart.total_price || 0);
      render(basis / 100, qty);
    } catch (err) {
      if (window.VE_DEBUG) console.warn('[VE] ladder sync failed:', err);
    }
  }

  // ── added-to-bag sheet ──────────────────────────────────────────────────
  // Nothing auto-navigates: the shopper closes it to keep shopping, or picks
  // the bag / checkout themselves.
  let lastFocus = null;
  function focusables() {
    return sheet ? sheet.querySelectorAll('a[href], button:not([disabled])') : [];
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }
  function showAdded(payload) {
    if (!sheet) return;
    const it = payload && (payload.items ? payload.items[0] : payload);
    const q = sel => sheet.querySelector(sel);
    if (it) {
      const img = q('[data-ve-sheet-img]');
      const src = it.image || (it.featured_image && it.featured_image.url) || '';
      if (img) {
        // Never set src="" — the browser resolves it to the page URL and
        // re-downloads the document as an image.
        if (src) { img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); img.hidden = false; }
        else { img.removeAttribute('src'); img.hidden = true; }
        img.alt = it.product_title || '';
      }
      const nm = q('[data-ve-sheet-name]');   if (nm) nm.textContent = it.product_title || it.title || '';
      const vr = q('[data-ve-sheet-variant]');
      if (vr) vr.textContent = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      const pr = q('[data-ve-sheet-price]');  if (pr) pr.textContent = money((it.price || 0) / 100);
      const wa = q('[data-ve-sheet-was]');
      const orig = it.original_price || 0;
      if (wa) {
        const show = orig > (it.price || 0);
        wa.hidden = !show;
        if (show) wa.textContent = money(orig / 100);
      }
    }
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const f = focusables();
    if (f.length) { try { f[0].focus(); } catch (e) {} }
  }

  // ── theme cart refresh WITHOUT the drawer popping open ───────────────────
  // getCart() re-renders the drawer, but on the way it dispatches
  // theme:product:added, whose listener was bound at connectedCallback — so
  // reassigning the method cannot unregister it. Instead we stop the event in
  // the CAPTURE phase while our own refresh is in flight. Deterministic: no
  // timing bet, and it can never leave a theme method permanently stubbed.
  if (!window.__veDrawerGuard) {
    window.__veDrawerGuard = true;
    document.addEventListener('theme:product:added', function (e) {
      if (window.__veSuppressDrawerOpen) e.stopImmediatePropagation();
    }, true);
  }
  let suppressTimer = null;
  function veRefreshThemeCartSilently() {
    window.__veSuppressDrawerOpen = true;
    clearTimeout(suppressTimer);
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    // Generous window: the refresh is a network round trip. We deliberately do
    // NOT force-close the drawer afterwards — that cannot tell our open from
    // the shopper's, and it was slamming the drawer shut on a qty edit.
    suppressTimer = setTimeout(function () { window.__veSuppressDrawerOpen = false; }, 4000);
  }
  function veCartChanged() {
    document.dispatchEvent(new CustomEvent('ds:cart:updated'));
    veRefreshThemeCartSilently();
  }

  let syncTimer = null;
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(sync, 150); }

  if (el && !root.__veLadderBound) {
    root.__veLadderBound = true;
    if (sheet) {
      sheet.querySelectorAll('[data-ve-sheet-close]').forEach(function (b) {
        b.addEventListener('click', closeSheet);
      });
      document.addEventListener('keydown', function (e) {
        if (sheet.hidden) return;
        if (e.key === 'Escape') { closeSheet(); return; }
        if (e.key !== 'Tab') return;
        const f = focusables();
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    sync();
    ['ds:cart:updated', 'cart:updated', 'theme:cart:change', 'theme:cart:add', 'theme:product:added']
      .forEach(function (ev) { document.addEventListener(ev, scheduleSync); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleSync(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleSync(); });

    // Catch-all for any code path we do not control (drawer, cart page, apps).
    // Read-only: it only triggers a re-read of /cart.js, never a mutation, so
    // it cannot duplicate an add the way a mutating interceptor would.
    if (!window.__veCartHook) {
      window.__veCartHook = true;
      const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
      const _fetch = window.fetch;
      window.fetch = function () {
        const out = _fetch.apply(this, arguments);
        try {
          const a0 = arguments[0];
          const url = String((a0 && a0.url) || a0 || '');
          if (CART_WRITE.test(url)) {
            // Only on success. A 422 "sold out" changed nothing, and firing the
            // refresh cycle on it is pure noise.
            out.then(function (r) { if (r && r.ok) veCartChanged(); }).catch(function () {});
          }
        } catch (e) {}
        return out;
      };
      const _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        try {
          if (CART_WRITE.test(String(u || ''))) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) veCartChanged();
            });
          }
        } catch (e) {}
        return _open.apply(this, arguments);
      };
    }
  }
  return { sync: sync, showAdded: showAdded, render: render };
};
